import { Bar, Column } from '@ant-design/plots'

import { colors } from '../../colorPalete'

const BarChart = ({ data, productProfiling, fields }) => {
  // let data2= [];

  let testData = [
    {
      month: 'January',
      conversion: 10,
    },
    {
      month: 'February',
      conversion: 20,
    },
    {
      month: 'March',
      conversion: 15,
    },
    {
      month: 'April',
      conversion: 16,
    },
    {
      month: 'May',
      conversion: 7,
    },
    {
      month: 'June',
      conversion: 12,
    },
    {
      month: 'July',
      conversion: 5,
    },
    {
      month: 'August',
      conversion: 35,
    },
    {
      month: 'September',
      conversion: 20,
    },
    {
      month: 'October',
      conversion: 9,
    },
    {
      month: 'November',
      conversion: 12,
    },
    {
      month: 'December',
      conversion: 7,
    },
  ]

  let finalData = []

  // data && data.orders && data.orders.length>0 && data.orders.map((item)=>{

  //   data2.push({ date: moment(item.invoiceDate).format('Do MMM YYYY'),
  //       amount: parseInt(item.netTotal),})
  // })
  //  var data = [
  //    {
  //      date: "1/7/2021",
  //    amount: 38,
  //    },
  //    {
  //      date: "1/7/2021",
  //    amount: 52,
  //  },
  //  ];

  let Date = []
  fields[0] === 'date' &&
    // eslint-disable-next-line
    data.map((dataObj) => {
      // eslint-disable-next-line
      const index = Date.indexOf(dataObj.date)
      if (index === -1) {
        Date.push(dataObj.date)
        finalData.push({
          date: dataObj.date,
          amount: dataObj.amount,
        })
      } else {
        let tempAmount = finalData[index].amount
        tempAmount = tempAmount + dataObj.amount
        finalData[index].amount = tempAmount
      }
    })

  let profilingData = []

  productProfiling &&
    // eslint-disable-next-line
    productProfiling.map((data) => {
      profilingData.push({
        shop: data.shopName ? data.shopName : 'unspecified',
        count: data.count,
      })
    })

  var config = {
    data:
      fields[0] === 'date' ? finalData : productProfiling ? profilingData : data ? data : testData,
    xField: fields ? fields[0] : 'month',
    yField: fields ? fields[1] : 'conversion',
    colorField: fields ? fields[0] : 'month',
    seriesField: '',
    // color: ["#8A1B6A", "#008060"],
    color: fields[1] === 'amount' ? '#fff' : '#051422',
    // color: "#56B977",
    // color : "#769982",
    // color: function color(_ref) {
    //   var type = _ref.amount;
    //   if (type >= 1000) {
    //     return brandColor;
    //   }
    //   return paletteSemanticRed;
    // },
    legend: { position: 'top-left' },
    barBackground: { style: { fill: 'rgba(0,0,0,0.1)' } },
    interactions: [
      {
        date: 'active-region',
        enable: false,
      },
    ],
  }
  var config2 = {
    data: data,
    xField: fields[1],
    yField: fields[0],
    color: colors,
    // color: [
    //   "#757bc8ff",
    //   "#8187dcff",
    //   "#8e94f2ff",
    //   "#93a6ed",
    //   "#ada7ffff",
    //   "#bbadffff",
    //   "#bbb2feff",
    //   "#dab6fcff",
    //   "#ddbdfcff",
    //   "#e0c3fcff",
    // ],
    // color: [
    //   "#CF8060",
    //   "#8A1B6A",
    //   "#511056",
    //   "#22071a",
    //   "#e733a8",
    //   "#D3140F",
    //   "#AE291F",
    //   "#ABC780",
    //   "#0A8B45",
    //   "#00e0a8",
    //   "#008060",
    //   "#8A1B6A",
    //   "#A3456E",
    //   "#2C2A23",
    //   "#D73555",
    //   "#00140F",
    //   "#00291F",
    //   "#CF5326",
    //   "#CF4534",
    //   "#C2A3D6",
    // ],
    seriesField: fields[0],
    legend: { position: 'top-left' },
    // barBackground: { style: { fill: "rgba(0,0,0,0.1)" } },
    // interactions: [
    //   {
    //     date: "active-region",
    //     enable: false,
    //   },
    // ],
  }
  return (
    <>
      {fields[0] === 'product' ? (
        <Bar
          {...config2}
          // style={{ height: "1000px", maxHeight: "25rem", width: "60%" }}
          style={{ height: 'auto', maxHeight: 'auto' }}
        />
      ) : (
        <Column
          {...config}
          // loading={data === undefined ? true : false}
          style={{ margin: '5rem 0', width: '100%' }}
        />
      )}
    </>
  )
}

export default BarChart
